import { createApiQueryHook, type IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, type RelationalValue } from "../../utils/filters";
import type { IFollowUp } from "../types/IFollowUp";
import type { IFollowUpResource } from "../types/IFollowUpResource";

export interface IFollowUpQueryParameters {
    followUp?: RelationalValue<IFollowUpResource>;
}

export type IFollowUpQueryResult = IFollowUp;

export const followUpQuery: IApiQueryFunction<IFollowUpQueryParameters> = ({ followUp }) => {
    if (!followUp) {
        return;
    }

    return {
        method: "GET",
        url: `/follow_ups/${mapRelationalValue(followUp)}`,
    };
};

export const useFollowUpQuery = createApiQueryHook<IFollowUpQueryParameters, IFollowUpQueryResult>(followUpQuery);
